import React, { useState, useEffect, useRef } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import FlashAlert from "../Components/FlashAlert/FlashAlert";
import authService from "../services/auth.service";
import { useHistory, Link } from "react-router-dom";
import PasswordToggle from "../Components/PasswordToggle";
import {
  getPostLoginPath,
  PLATFORM_LOGIN_UNAUTHORIZED,
  shouldRejectPlatformLogin,
} from "../utils/roles";
import { appPath } from "../utils/appSlug";
import { decodeAccessToken } from "../utils/session";
import "./login.css";

const Login = ({ appSlug, ...props }) => {
  let history = useHistory()
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [successfulLogin, setSuccessfulLogin] = useState(true);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [genericError, setGenericError] = useState(false);
  const [unauthorized, setUnauthorized] = useState(false);
  const [loading, setLoading] = useState(false);
  const emailField = useRef(null);

  useEffect(() => {
    if (!props.loginStatus?.sub) return;
    history.replace(
      getPostLoginPath(props.loginStatus, appSlug || props.loginStatus.application_slug)
    );
  }, [appSlug, history, props.loginStatus]);


  const onPasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const onUsernameChange = (e) => {
    setUsername(e.target.value);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (emailField.current) {
        setUsername(emailField.current.value);
      }
    }, 100);
    return () => clearInterval(interval);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(false);
    setSuccessfulLogin(true);
    setGenericError(false);
    setUnauthorized(false);
    setLoading(true);
    try {
      const loginUsername = emailField.current?.value || username;
      await authService.login(loginUsername, password);
      localStorage.removeItem('authError')
      const user = authService.getCurrentUser();
      const payload = user?.access_token ? decodeAccessToken(user.access_token) : null;
      if (shouldRejectPlatformLogin(appSlug, payload)) {
        authService.logout();
        if (props.setLoginStatus) {
          props.setLoginStatus({});
        }
        setFormSubmitted(true);
        setUnauthorized(true);
        return;
      }
      if (payload && props.setLoginStatus) {
        props.setLoginStatus(payload);
      }
      history.push(getPostLoginPath(payload, appSlug), { login: true, successReason: payload?.platform_role === "utente_base" ? "Accesso effettuato." : undefined });
    } catch (error) {
      setFormSubmitted(true);
      if (error.response?.status === 401) {
        setSuccessfulLogin(false);
      } else {
        setGenericError(true);
      }
    } finally {
      setLoading(false);
    }
  };

  const displayAlert = (e) => {
    if (history.location.state) {
      if (history.location.state['failReason']) {
        return <FlashAlert variant="danger">{history.location.state['failReason']}</FlashAlert>
      }
      if (history.location.state['successReason']) {
        return <FlashAlert variant="success">{history.location.state['successReason']}</FlashAlert>
      }
      if (history.location.state['warnReason']) {
        return <FlashAlert variant="warning">{history.location.state['warnReason']}</FlashAlert>
      }
    }
    if (formSubmitted) {
      if (unauthorized) {
        return <FlashAlert variant="danger">{PLATFORM_LOGIN_UNAUTHORIZED}</FlashAlert>
      }
      if(!successfulLogin){
        return <FlashAlert variant="danger">Le credenziali non sono corrette</FlashAlert>
      }
      if(genericError){
        return <FlashAlert variant="danger">Si è verificato un errore imprevisto, se continui a riscontrare questo problema, contatta infoceformedsrl@gmail.com</FlashAlert>
      }
    }
  };

  return (
    <div className={`login-page${!appSlug ? " login-page--platform" : ""}`}>
      <div className="login-card">
        {displayAlert()}
        <p className="login-kicker">Area riservata</p>
        <h1 className="login-title">{appSlug ? "Accedi" : "Accedi al gestionale"}</h1>
        <p className="login-subtitle">
          {appSlug
            ? "Inserisci i tuoi dati per accedere"
            : "Accesso riservato ad amministratori e personale autorizzato."}
        </p>
        <Form onSubmit={handleSubmit} className="login-form">
          <Form.Group className="mb-3" controlId="em1">
            <Form.Label>Email</Form.Label>
            <Form.Control
              required
              ref={emailField}
              name="em1"
              type="email"
              placeholder="Inserisci email"
              value={username}
              onChange={onUsernameChange}
              autoComplete="username"
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="pw1">
            <Form.Label>Password</Form.Label>
            <PasswordToggle
              value={password}
              onChange={onPasswordChange}
              placeholder="Inserisci la password"
              autoComplete="current-password"
            />
          </Form.Group>
          <Button
            className="login-submit"
            size="lg"
            variant="primary"
            type="submit"
            disabled={loading}>
            {loading ? "Accesso in corso..." : "Accedi"}
          </Button>
        </Form>
        {appSlug && (
        <>
        <div className="login-register-box">
          <p className="login-register-prompt">
            Non hai un account? <Link to={appPath(appSlug, "register")}>Registrati ora</Link>.
          </p>
        </div>
        <div className="login-reset">
          <p>Non riesci ad accedere?</p>
          <Link to={appPath(appSlug, "requestreset")}>Reimposta la tua password</Link>
        </div>
        </>
        )}
      </div>
    </div>
  );
};

export default Login;
